import styled from "styled-components";
import { useDispatch, useSelector} from "react-redux";
import { FormDetail } from "./FormDetail";
import { FormPeserta } from "./FormPeserta";
import { useEffect, useState } from "react";
import { FormValidasi } from "./FormValidasi";
import { FormKegiatan } from "./FormKegiatan";
import { FormPenyelenggara } from "./FormPenyelenggara";
import { useHistory, useLocation } from "react-router-dom";
import { getDetailAsync, getDokumenAsync, initializeCreateMonev, updateFile } from "../../../reducers/monev/monev.actions";
import { allowSave } from "../../../store/helpers";
import { RootState } from "../../../store/rootReducer";
import { PermissionMenuName } from "../../../interfaces/UserRole";

export const MonevDetailPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [isNew, setIsNew] = useState<boolean>(false);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.monevPartner].ACCESS);

  useEffect(() => {
    window.scrollTo(0, 0);
    let isNew = false;
    const paths = location.pathname.split("/");
    if (paths[3] === 'create') isNew = true;

    const idDokumen = parseInt(paths[2]);
    if (!idDokumen || isNaN(idDokumen)) {
      history.push(`/monev`);
      return;
    };

    dispatch(updateFile(null));
    dispatch(getDokumenAsync.request({ DOK_ID: idDokumen }));

    if (isNew) {
      setIsNew(true);
      dispatch(initializeCreateMonev( idDokumen ));
    } else {
      setIsNew(false);
      const idMonev = parseInt(paths[3]);
      if (idMonev && !isNaN(idMonev)) {
        dispatch(getDetailAsync.request({ MONEV_ID: idMonev }))
      } else {
        history.push(`/monev/${idDokumen}/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <MonevDetailPageWrapper>
      <section className="content-header">
        <h1>Monitoring Kerjasama & Evaluasi</h1>
      </section>
      <section className="content">
        <section className="content">
          <div className="row">
            <div className="col-lg-4">
              <FormDetail />
            </div>
            <div className="col-lg-4">
              <FormPenyelenggara />
              <FormPeserta />
            </div>
            <div className="col-lg-4">
              <FormValidasi />
              <FormKegiatan />
            </div>
          </div>
        </section>
      </section>
    </MonevDetailPageWrapper>
  );
};

const MonevDetailPageWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
  }
  .sticky {
    background: #fff;
    position: sticky;
    top: 0;
  }
`;